<div class="container-fluid department-management">
  <div class="row">
    <!-- Left Side: Department Tree Structure -->
    <div class="col-md-5 left-panel">
      <mat-card>
        <mat-card-header>
          <mat-card-title>組織部門結構</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <!-- 自定義樹狀結構取代 Material Tree -->
          <div class="custom-tree-container">
            <!-- 顯示加載動畫 -->
            <div *ngIf="isLoading" class="spinner-container">
              <mat-spinner diameter="40"></mat-spinner>
            </div>

            <!-- 自定義樹狀結構 -->
            <div *ngIf="!isLoading" class="custom-tree">
              <ng-container *ngFor="let node of dataSource.data">
                <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { $implicit: node, level: 0 }"></ng-container>
              </ng-container>
            </div>

            <!-- 樹節點模板 -->
            <ng-template #treeNodeTemplate let-node let-level="level">
              <div class="tree-node"
                   [style.padding-left]="level * 12 + 'px'"
                   draggable="true"
                   (dragstart)="onDragStart($event, node)"
                   (dragend)="onDragEnd()"
                   (dragover)="onDragOver($event, node)"
                   (drop)="onDrop($event, node)"
                   [class.drag-over-before]="allowDrop && draggedNode?.id !== node.id && dropPosition === 'before'"
                   [class.drag-over-inside]="allowDrop && draggedNode?.id !== node.id && dropPosition === 'inside'"
                   [class.drag-over-after]="allowDrop && draggedNode?.id !== node.id && dropPosition === 'after'">

                <!-- 簡化展開/收起符號，使用 Font Awesome -->
                <span
                  *ngIf="node.children?.length"
                  class="toggle-icon"
                  (click)="toggleNodeExpansion(node)">
                  <i [class]="isNodeExpanded(node) ? 'fas fa-caret-down' : 'fas fa-caret-right'"></i>
                </span>

                <!-- 無子節點時的佔位 -->
                <span *ngIf="!node.children?.length" class="node-spacer"></span>

                <!-- 節點內容 -->
                <span
                  class="node-content"
                  [class.selected]="selectedDepartment?.id === node.id"
                  [class.dragged]="draggedNode?.id === node.id"
                  (click)="selectDepartment(convertToFlatNode(node))">
                  {{ node.name }} ({{ node.userCount }}人)
                </span>
              </div>

              <!-- 子節點 -->
              <div *ngIf="node.children?.length && isNodeExpanded(node)" class="child-nodes">
                <ng-container *ngFor="let childNode of node.children">
                  <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { $implicit: childNode, level: level + 1 }"></ng-container>
                </ng-container>
              </div>
            </ng-template>
          </div>

          <!-- Add New Department Button -->
          <mat-divider class="my-3"></mat-divider>
          <div class="department-actions">
            <button mat-raised-button color="primary" (click)="toggleAddDepartmentForm()">
              <mat-icon>add</mat-icon>
              {{ showAddDepartmentForm ? '取消新增' : '新增部門' }}
            </button>
          </div>

          <!-- Add New Department Form -->
          <div class="add-department-section" *ngIf="showAddDepartmentForm">
            <h3>新增部門</h3>
            <form class="add-dept-form">
                <mat-form-field appearance="outline" class="full-width">
                <mat-label>上級部門</mat-label>
                <mat-select [(ngModel)]="newDepartmentParentId" name="newDepartmentParentId">
                  <mat-option [value]="null">無（頂級部門）</mat-option>
                  <ng-container *ngFor="let node of treeControl.dataNodes">
                    <mat-option [value]="node.id">{{ node.name }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>部門名稱</mat-label>
                <input matInput [(ngModel)]="newDepartmentName" name="newDepartmentName" required>
              </mat-form-field>



              <div class="form-actions">
                <button mat-raised-button color="primary" (click)="addDepartment()">
                  <mat-icon>check</mat-icon> 確認新增
                </button>
                <button mat-button (click)="toggleAddDepartmentForm()">
                  <mat-icon>close</mat-icon> 取消
                </button>
              </div>
            </form>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Right Side: Department Details and User List -->
    <div class="col-md-7 right-panel">
      <div *ngIf="selectedDepartment" class="department-details">
        <!-- 部門標題 -->
        <div class="department-header">
          <div *ngIf="!editingDepartment" class="d-flex align-items-center justify-content-between w-100">
            <h2 class="department-title">{{ selectedDepartment.name }}</h2>
            <div class="department-actions">
              <button mat-icon-button color="primary" (click)="startEditDepartment()"
                      matTooltip="編輯部門名稱">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteDepartment()"
                      matTooltip="刪除部門">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <div *ngIf="editingDepartment" class="edit-dept-name">
            <mat-form-field appearance="outline">
              <mat-label>部門名稱</mat-label>
              <input matInput [(ngModel)]="editDepartmentName" name="editDepartmentName">
            </mat-form-field>
            <button mat-icon-button color="primary" (click)="saveEditDepartment()" matTooltip="保存">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="cancelEditDepartment()" matTooltip="取消">
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
          <h3 class="department-subtitle">部門成員 ({{ departmentUsers.length }} 人)</h3>
        </div>

        <!-- 部門用戶列表 - 改為直接使用列表形式 -->
        <div class="department-users-container">
          <div *ngFor="let user of departmentUsers" class="user-list-item">
            <div class="user-item-content">
              <div class="user-info">
                <mat-icon>person</mat-icon>
                <div class="user-details">
                  <h4 class="user-name">{{ user.name }}</h4>
                  <p class="user-email">{{ user.email }}</p>
                </div>
              </div>
              <button mat-icon-button color="warn" (click)="removeUserFromDepartment(user.id)"
                      matTooltip="從此部門移除使用者">
                <mat-icon>person_remove</mat-icon>
              </button>
            </div>
          </div>

          <div *ngIf="departmentUsers.length === 0" class="no-users-message">
            <mat-icon>info</mat-icon>
            <span>此部門目前沒有成員</span>
          </div>
        </div>

        <!-- Add User to Department Button -->
        <mat-divider class="my-3"></mat-divider>
        <div class="user-actions">
          <button mat-raised-button color="primary" (click)="toggleAddUserForm()">
            <mat-icon>person_add</mat-icon>
            {{ showAddUserForm ? '取消新增' : '新增成員' }}
          </button>
        </div>

        <!-- Add User to Department Form -->
        <div class="add-user-section" *ngIf="showAddUserForm">
          <h3>新增部門成員</h3>
          <div class="add-user-form">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>選擇使用者</mat-label>
              <mat-select [(ngModel)]="selectedUserToAdd" name="selectedUserToAdd">
                <mat-option *ngFor="let user of nonDepartmentUsers" [value]="user.id">
                  {{ user.name }} ({{ user.email }})
                </mat-option>
                <mat-option *ngIf="nonDepartmentUsers.length === 0" disabled>
                  沒有可新增的使用者
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div class="form-actions">
              <button mat-raised-button color="primary"
                      [disabled]="!selectedUserToAdd || nonDepartmentUsers.length === 0"
                      (click)="addUserToDepartment()">
                <mat-icon>check</mat-icon> 確認新增
              </button>
              <button mat-button (click)="toggleAddUserForm()">
                <mat-icon>close</mat-icon> 取消
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Placeholder when no department is selected -->
      <div *ngIf="!selectedDepartment" class="no-selection-message">
        <mat-icon class="large-icon">account_tree</mat-icon>
        <h3>請從左側選擇一個部門</h3>
        <p>選擇部門後，將在此處顯示其成員和詳細資訊</p>
      </div>
    </div>
  </div>
</div>
